<template>
        <!-- 修改密码弹窗-->
    <el-dialog title="修改密码" 
        :visible.sync="dialog" 
        :width='changeWidth' 
        :before-close="handleClose"
        center   
        :close-on-click-modal="false">
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item label="原始密码" prop="oldPassword" :label-width="formLabelWidth">
                    <el-input v-model="ruleForm.oldPassword" type="password" auto-complete="off" placeholder="请输入原始密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
                    <el-input v-model="ruleForm.newPassword" type="password" auto-complete="off" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="重复密码" prop="resetPassword" :label-width="formLabelWidth">
                    <el-input v-model="ruleForm.resetPassword" type="password" auto-complete="off" placeholder="请再次输入新密码"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitModifyForm('ruleForm')">确 定</el-button>
            <el-button @click="handleClose">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/ecmascript-6">
import * as services  from "./services"
import FormatDate from '@core/filters'
export default {
    props: {
        dialog: Boolean,
        default: false
    },
    data() {    
        var validPassword = (rule, value, callback) => {
            const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/
            if (!reg.test(value)) {
                callback(new Error('长度8到30位，至少包含大小写字母、数字、特殊字符三种组合类型！'))
            } else {
                callback()
            }
        }
         var validSamePass = (rule, value, callback) => {
            if (value === this.ruleForm.oldPassword) {
                callback(new Error('输入密码不能与原始密码相同!'))
            } else {
                callback()
            }
        }
        var validResetPass = (rule, value, callback) => {
            if (value !== this.ruleForm.newPassword) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return{
           changeWidth: '520px',
           ruleForm: {
               oldPassword: '',
               newPassword: '',
               resetPassword: ''
           },
            formLabelWidth: '80px',
            rules: {
                //弹窗校验规则
                oldPassword: [
                { required: true, message: '请输入原始密码', trigger: 'blur' },
                /* {min:6, message: '密码需长度6位以上', trigger: 'blur' },*/
                ],
                newPassword: [
                { required: true, message: '请输入新密码', trigger: 'blur' },
                /* {min:6, message: '密码需长度6位以上', trigger: 'blur' },*/
                  {validator: validSamePass, trigger: 'blur' },
                { validator: validPassword, trigger: 'blur' },
                ],
                resetPassword: [
                { required: true, message: '请再次输入新密码', trigger: 'blur' },
                /*  {min:6, message: '密码需长度6位以上', trigger: 'blur' },*/
                { validator: validPassword, trigger: 'blur' },
                {validator: validSamePass, trigger: 'blur' },
                { validator: validResetPass, trigger: 'blur' },
                ],
            },
        }
    },
    methods: {
        handleClose() {
            this.ruleForm = {
               oldPassword: '',
               newPassword: '',
               resetPassword: ''
            }
            this.$refs['ruleForm'].clearValidate()
             this.$emit('update:dialog', false)
        },
        /*  提交表单 */
        submitModifyForm() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                  services.updatePassword({ oldPwd: this.ruleForm.oldPassword, newPwd: this.ruleForm.newPassword })
                    .subscribe(data => {
                        if (data.response.data.code == 0) {
                            this.$message({
                                message: '修改成功！',
                                type: 'success',
                            })
                            this.handleClose()
                            this.$router.replace('/login')
                        } else if (data.response.data.code == 2) {
                                //用户未登录
                            this.$message({
                                message: '用户未登录',
                            type: 'error',
                        })
                            this.$router.replace('/login')
                        } else {
                            this.$message({
                                message: data.data.msg,
                                type: 'error',
                            })
                        }
                    })
                } else {
                    return false
                }
            })
        },

        
    }
}
</script>
<style scoped lang="less">
    .customer-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 350px);
        & p {
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #4A4A4A;
            letter-spacing: 0;
        }
    }
</style>
